export default __webpack_public_path__ + "cfa0e742a5be00bb3cf416d585798529.jpg";